import { MapBuilder, px, type Decor, type MapDef } from '../mapdef';

/** The Lantern Night Market: one long street, stalls on both sides, lanterns strung overhead. */
const W = 42;
const b = new MapBuilder(W, 24, 'n');
// Shophouses behind the northern stalls.
for (let i = 0; i < 7; i++) {
  const brick = i % 2 === 0;
  b.building(i * 6, 0, 6, 6, { roof: i % 3 === 0 ? 'U' : 'R', wall: brick ? 'K' : 'B', window: brick ? 'v' : 'w', roofRows: 4, doors: [], windows: [1, 4] });
}
// Rooftops of the southern row.
b.fill(0, 16, W, 8, 'R');
for (let x = 0; x < W; x += 12) b.fill(x, 16, 6, 8, 'U');

const at = (tx: number, ty: number) => ({ x: px(tx), y: px(ty) });

const decor: Decor[] = [
  // Strings of lanterns across the street (drawn above everyone).
  ...[2, 10, 18, 26, 34].map((tx, i) => ({ kind: 'lanternString' as const, x: px(tx), y: px(11), w: px(8), variant: i })),
  { kind: 'stool', ...at(27, 14) },
  { kind: 'stool', ...at(29, 14) },
  { kind: 'foodTable', ...at(28, 15), w: px(3), solid: { x: px(26) + 8, y: px(15) - 8, w: px(3), h: 8 } },
  { kind: 'stool', ...at(32, 14) },
  { kind: 'stool', ...at(34, 14) },
  { kind: 'foodTable', ...at(33, 15), w: px(3), solid: { x: px(31) + 8, y: px(15) - 8, w: px(3), h: 8 } },
  { kind: 'trashBin', ...at(38, 15), solid: { x: px(38) - 5, y: px(15) - 4, w: 10, h: 4 } },
  { kind: 'trashBin', ...at(39, 15), variant: 1, solid: { x: px(39) - 5, y: px(15) - 4, w: 10, h: 4 } },
  { kind: 'scooter', ...at(1, 15), variant: 0 },
  { kind: 'scooter', ...at(40, 8), variant: 1 },
];

export const MARKET_W = W;

export const market: MapDef = {
  id: 'market',
  w: b.w,
  h: b.h,
  rows: b.rows(),
  indoor: false,
  theme: { wallFace: '#e9dcc3', wallLight: '#f6ecd8', wainscot: '#8a5c3a', wallTop: '#3a2a20' },
  doors: [{ tiles: [[0, 10], [0, 11]], to: 'town', arrive: { x: px(2) + 8, y: px(27) + 8, facing: 'right' } }],
  decor,
  areas: [
    { key: 'marketGames', rect: { x: px(19), y: 0, w: px(20), h: px(11) } },
    { key: 'market', rect: { x: 0, y: 0, w: px(W), h: px(24) } },
  ],
  lights: [
    ...[2, 6, 10, 14, 18, 22, 26, 30, 34, 38].map((tx, i) => ({ x: px(tx) + 8, y: px(10), r: 70, color: i % 2 ? '255,120,80' : '255,190,90' })),
    ...[4, 10, 16, 22, 28, 34].map((tx) => ({ x: px(tx), y: px(7), r: 46, color: '255,240,200' })),
  ],
};
